import Swiper from "swiper";
import {Navigation, Pagination, Scrollbar, Virtual, Keyboard} from 'swiper/modules';
import hoverintent from "../../../default/global/js/hoverintent";

export function elements() {
    introbanner();
    herobanner();
    teaserBanner();
    collectionAthletesArticles();
    collectionTabs();
}

/***
 Hero banner element (Startseite): eine oder mehrere Instanzen ("Haelften"), analog introBanner.
 Desktop startet das Video per Mouseover/Hoverintent (Standbild wird ausgeblendet). Auf Mobilgeraeten
 entscheidet pro Instanz die Redakteurs-Option "mobileMode", ob Standbild oder Video gezeigt wird -
 kein automatisches Video-Autoplay mehr erzwungen. Bei mehr als einer Instanz wird auf Mobil zusaetzlich
 ein Swiper daraus gebaut (wie bisher beim introBanner).
***/
function herobanner() {
    let heroHalfs = document.querySelectorAll(".heroBanner__half");
    const heroWrapper = document.querySelector(".heroBanner__wrapper");
    const isMobile = window.innerWidth < 1024 || window.outerWidth < 1024;

    for (let heroHalf of heroHalfs) {
        let video = heroHalf.querySelector("video");

        if (video) {
            video.setAttribute("aria-hidden", "true");

            // Das Video-Sitepart liefert im reusch_b2c-Theme lazy <source data-src="...">.
            // Quelle sofort aufloesen, statt auf das globale videoLazy() (aus main.js) zu warten -
            // das wuerde jedes Video beim Sichtbarwerden automatisch abspielen und unser eigenes
            // Hover-/mobileMode-Verhalten aushebeln.
            let lazySource = video.querySelector("source[data-src]");
            if (lazySource && !lazySource.src) {
                lazySource.src = lazySource.dataset.src;
                video.load();
            }

            // Eigene Steuerung hat Vorrang vor einem evtl. am Sitepart gesetzten "Autoplay"
            video.autoplay = false;
            video.removeAttribute("autoplay");

            if (isMobile) {
                // Nur abspielen, wenn die Redakteurs-Option auf "Video" steht - sonst bleibt das Standbild sichtbar
                video.autoplay = heroHalf.classList.contains("heroBanner__half--mobileVideo");
            } else {
                heroHalf.addEventListener("mouseover", function() {
                    void video.play().catch(function() {});
                });

                heroHalf.addEventListener("mouseleave", function() {
                    video.pause();
                });
            }
        }

        let zIndexVal = heroHalf.style.zIndex;

        // Der Hover-Expand-Effekt (Haelfte wird breiter, andere ausgeblendet) ist ein reines
        // Desktop-Layout-Detail. hoverintent() registriert bei jedem Aufruf zusaetzlich einen
        // globalen touchstart-Listener (hoverintent.js), der den ersten Touch auf dem Element abfaengt
        // (preventDefault/stopImmediatePropagation), um Hover auf Touch zu simulieren - das wuerde auf
        // Mobil die Swiper-Wischgeste blockieren. Daher nur auf Desktop registrieren.
        if (!isMobile) {
            hoverintent(heroHalf,
                500,
                function() {
                    if (heroWrapper) heroWrapper.classList.add("hoverActive");
                    heroHalf.style.zIndex = 2;
                }, function () {
                    if (heroWrapper) heroWrapper.classList.remove("hoverActive");
                    setTimeout(function(){
                        heroHalf.style.zIndex = zIndexVal;
                    }, 500);
                });
        }

        // Desktop: Tastatur-Fokus spiegelt Hover-Verhalten
        if (!isMobile) {
            heroHalf.addEventListener('focusin', () => {
                if (heroWrapper) heroWrapper.classList.add('hoverActive');
                heroHalf.classList.add('hoverintent');
                heroHalf.style.zIndex = 2;
            });
            heroHalf.addEventListener('focusout', (e) => {
                if (!heroHalf.contains(e.relatedTarget)) {
                    if (heroWrapper) heroWrapper.classList.remove('hoverActive');
                    heroHalf.classList.remove('hoverintent');
                    setTimeout(() => { heroHalf.style.zIndex = zIndexVal; }, 500);
                }
            });
        }
    }

    initHeroBannerSwiper();

    new ResizeObserver(() => {
        initHeroBannerSwiper();
    }).observe(document.body);
}

function initHeroBannerSwiper() {
    if (window.innerWidth < 1024 || window.outerWidth < 1024) {
        let swiperContainer = document.querySelector(".heroBanner__swiper");
        let heroHalfs = document.querySelectorAll(".heroBanner__half");

        // Nur mit mehr als einer Instanz sinnvoll (sonst gibt es nichts zu "swipen")
        if (swiperContainer && heroHalfs.length > 1 && !swiperContainer.classList.contains("swiper")) {
            const tc = (typeof GLOBALS !== 'undefined' && GLOBALS.tc) ? GLOBALS.tc : {};
            const labelRegion  = tc.ariaSwiperBannerRegion || 'Banner-Slideshow';
            const labelPrev    = tc.ariaSwiperPrev         || 'Vorheriges Banner';
            const labelNext    = tc.ariaSwiperNext         || 'Nächstes Banner';
            const labelSlide   = tc.ariaSwiperSlide        || 'Folie';

            // Barrierefreiheit: Region + Carousel-Rolle
            swiperContainer.setAttribute('role', 'region');
            swiperContainer.setAttribute('aria-roledescription', 'carousel');
            swiperContainer.setAttribute('aria-label', labelRegion);

            swiperContainer.classList.add("swiper");

            // Dekorative Scrollbar
            swiperContainer.innerHTML += "<div class='swiper-scrollbar' aria-hidden='true'></div>";

            // Navigation: <button> statt <div> + aria-label
            swiperContainer.innerHTML += `<button class='swiper-button-prev' aria-label='${labelPrev}'><i class='icon icon-arrow-left' aria-hidden='true'></i></button>`;
            swiperContainer.innerHTML += `<button class='swiper-button-next' aria-label='${labelNext}'><i class='icon icon-arrow-right' aria-hidden='true'></i></button>`;

            // Live-Region fuer Slide-Wechsel-Ansagen
            const liveRegion = document.createElement('div');
            liveRegion.setAttribute('aria-live', 'polite');
            liveRegion.setAttribute('aria-atomic', 'true');
            liveRegion.className = 'screenreader-only';
            swiperContainer.appendChild(liveRegion);

            let swiperWrapper = document.querySelector(".heroBanner__wrapper");
            if (swiperWrapper) {
                swiperWrapper.classList.add("swiper-wrapper");
            }

            // heroHalfs neu abfragen: die innerHTML+=-Aufrufe oben haben .heroBanner__swiper
            // neu geparst, die urspruenglich abgefragten Elemente sind dadurch verwaiste Referenzen
            // (identisches Muster wie im bewaehrten introBanner-Pendant).
            heroHalfs = document.querySelectorAll(".heroBanner__half");

            const totalSlides = heroHalfs.length;
            let slideIndex = 1;
            for (let heroHalf of heroHalfs) {
                heroHalf.classList.add("swiper-slide");

                // Slide-Rolle und Beschriftung
                heroHalf.setAttribute('role', 'group');
                heroHalf.setAttribute('aria-roledescription', labelSlide);
                heroHalf.setAttribute('aria-label', `${slideIndex} / ${totalSlides}`);

                // Dekoratives Bild: leerer Alt-Text falls keiner gesetzt
                const img = heroHalf.querySelector('.heroBanner__image img');
                if (img && !img.hasAttribute('alt')) {
                    img.setAttribute('alt', '');
                }

                // Video ist dekorativ
                const video = heroHalf.querySelector('video');
                if (video) {
                    video.setAttribute('aria-hidden', 'true');
                }

                slideIndex++;
            }

            Swiper.use([Scrollbar, Navigation, Keyboard]);
            const swiper = new Swiper(".heroBanner__swiper", {
                scrollbar: {
                    el: ".swiper-scrollbar",
                    hide: false
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                slidesPerView: 'auto',
                on: {
                    init: function () {
                        const activeBanner = swiperContainer.querySelector(".heroBanner__half.swiper-slide-active");
                        if (activeBanner) {
                            const video = activeBanner.querySelector("video");
                            if (video && activeBanner.classList.contains("heroBanner__half--mobileVideo")) {
                                void video.play().catch(function() {});
                            }
                        }
                    }
                }
            });

            swiper.on("slideChange", function () {
                const index_currentSlide = this.realIndex;
                const slides = this.slides;

                // Live-Region aktualisieren
                liveRegion.textContent = `${labelSlide} ${index_currentSlide + 1} / ${totalSlides}`;

                let counter = 0;
                for (let slide of slides) {
                    const video = slide.querySelector("video");
                    if (video) {
                        if (counter === index_currentSlide && slide.classList.contains("heroBanner__half--mobileVideo")) {
                            void video.play().catch(function() {});
                        } else {
                            video.pause();
                        }
                    }
                    counter++;
                }
            });
        }
    }
}

function introbanner() {
    let introHalfs = document.querySelectorAll(".introBannerHalf");
    const introWrapper = document.querySelector(".introBannerWrapper");
    const isMobile = window.innerWidth < 1024 || window.outerWidth < 1024;

    for(let introHalf of introHalfs) {
        let video = introHalf.querySelector("video");

        if(video) {
            if(isMobile) {
                video.autoplay = true;
            } else {
                introHalf.addEventListener("mouseover", function() {
                    void video.play().catch(function() {});
                });

                introHalf.addEventListener("mouseleave", function() {
                    video.pause();
                });
            }
        }

        let zIndexVal = introHalf.style.zIndex;
        hoverintent(introHalf,
            500,
            function() {
                if (introWrapper) introWrapper.classList.add("hoverActive");
                introHalf.style.zIndex = 2;
            }, function () {
                if (introWrapper) introWrapper.classList.remove("hoverActive");
                setTimeout(function(){
                    introHalf.style.zIndex = zIndexVal;
                }, 500);
            });

        // Desktop: Tastatur-Fokus spiegelt Hover-Verhalten
        if (!isMobile) {
            introHalf.addEventListener('focusin', () => {
                if (introWrapper) introWrapper.classList.add('hoverActive');
                introHalf.classList.add('hoverintent');
                introHalf.style.zIndex = 2;
            });
            introHalf.addEventListener('focusout', (e) => {
                if (!introHalf.contains(e.relatedTarget)) {
                    if (introWrapper) introWrapper.classList.remove('hoverActive');
                    introHalf.classList.remove('hoverintent');
                    setTimeout(() => { introHalf.style.zIndex = zIndexVal; }, 500);
                }
            });
        }
    }

    initIntroBannerSwiper();

    new ResizeObserver(() => {
        initTeaserBannerSwiper();
    }).observe(document.body);
}

function initIntroBannerSwiper() {
    if(window.innerWidth < 1024 || window.outerWidth < 1024) {
        let swiperContainer = document.querySelector(".introBannerSwiper");
        if(swiperContainer && !swiperContainer.classList.contains("swiper")) {
            const tc = (typeof GLOBALS !== 'undefined' && GLOBALS.tc) ? GLOBALS.tc : {};
            const labelRegion  = tc.ariaSwiperBannerRegion || 'Banner-Slideshow';
            const labelPrev    = tc.ariaSwiperPrev         || 'Vorheriges Banner';
            const labelNext    = tc.ariaSwiperNext         || 'Nächstes Banner';
            const labelSlide   = tc.ariaSwiperSlide        || 'Folie';

            // Barrierefreiheit: Region + Carousel-Rolle
            swiperContainer.setAttribute('role', 'region');
            swiperContainer.setAttribute('aria-roledescription', 'carousel');
            swiperContainer.setAttribute('aria-label', labelRegion);

            swiperContainer.classList.add("swiper");

            // Dekorative Scrollbar
            swiperContainer.innerHTML += "<div class='swiper-scrollbar' aria-hidden='true'></div>";

            // Navigation: <button> statt <div> + aria-label
            swiperContainer.innerHTML += `<button class='swiper-button-prev' aria-label='${labelPrev}'><i class='icon icon-arrow-left' aria-hidden='true'></i></button>`;
            swiperContainer.innerHTML += `<button class='swiper-button-next' aria-label='${labelNext}'><i class='icon icon-arrow-right' aria-hidden='true'></i></button>`;

            // Live-Region für Slide-Wechsel-Ansagen
            const liveRegion = document.createElement('div');
            liveRegion.setAttribute('aria-live', 'polite');
            liveRegion.setAttribute('aria-atomic', 'true');
            liveRegion.className = 'screenreader-only';
            swiperContainer.appendChild(liveRegion);

            let swiperWrapper = document.querySelector(".introBannerWrapper");
            if (swiperWrapper) {
                swiperWrapper.classList.add("swiper-wrapper");
            }

            let introHalfs = document.querySelectorAll(".introBannerHalf");
            const totalSlides = introHalfs.length;
            let slideIndex = 1;
            for (let introHalf of introHalfs) {
                introHalf.classList.add("swiper-slide");

                // Slide-Rolle und Beschriftung
                introHalf.setAttribute('role', 'group');
                introHalf.setAttribute('aria-roledescription', labelSlide);
                introHalf.setAttribute('aria-label', `${slideIndex} / ${totalSlides}`);

                // Dekoratives Bild: leerer Alt-Text falls keiner gesetzt
                const img = introHalf.querySelector('.introBannerImage img');
                if (img && !img.hasAttribute('alt')) {
                    img.setAttribute('alt', '');
                }

                // Video ist dekorativ
                const video = introHalf.querySelector('video');
                if (video) {
                    video.setAttribute('aria-hidden', 'true');
                }

                slideIndex++;
            }

            Swiper.use([Scrollbar, Navigation, Keyboard]);
            const swiper = new Swiper(".introBannerSwiper", {
                scrollbar: {
                    el: ".swiper-scrollbar",
                    hide: false
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                slidesPerView: 'auto',
                on: {
                    init: function () {
                        const activeBanner = swiperContainer.querySelector(".introBannerHalf.swiper-slide-active");
                        if (activeBanner) {
                            const video = activeBanner.querySelector("video");
                            if (video) void video.play().catch(function() {});
                        }
                    }
                }
            });

            swiper.on("slideChange", function () {
                const index_currentSlide = this.realIndex;
                const slides = this.slides;

                // Live-Region aktualisieren
                liveRegion.textContent = `${labelSlide} ${index_currentSlide + 1} / ${totalSlides}`;

                let counter = 0;
                for (let slide of slides) {
                    const video = slide.querySelector("video");
                    if (video) {
                        if (counter === index_currentSlide) {
                            void video.play().catch(function() {});
                        } else {
                            video.pause();
                        }
                    }
                    counter++;
                }
            });
        }
    }
}

/***
 Teaser banner element
***/
function teaserBanner() {
    initTeaserBannerSwiper();

    new ResizeObserver(() => {
        initTeaserBannerSwiper();
    }).observe(document.body);
}

function initTeaserBannerSwiper() {
    let rows = document.querySelectorAll(".row:has(> .teaserboxSmall, > .teaserboxBig)");
    for(let row of rows) {
        if(window.innerWidth < 1024 || window.outerWidth < 1024) {
            if(!row.classList.contains("swiper")) {
                row.classList.add("swiper");
                let html = row.innerHTML;
                if(!html.includes("swiper-wrapper")) {
                    let newHtml = "<div class=\"swiper-wrapper\">" + html + "</div><div class='swiper-scrollbar teaserscrollbar'></div>";
                    row.innerHTML = newHtml;
                    row.classList.add("teaserSwiper");
                }

                let contentBoxes = row.querySelectorAll(".contentBox");
                for(let contentBox of contentBoxes) {
                    contentBox.classList.add("swiper-slide");
                }

                Swiper.use([Scrollbar]);
                const teaserSwiper = new Swiper(".teaserSwiper", {
                    scrollbar: {
                        el: ".teaserscrollbar",
                        hide: false
                    },
                    slidesPerView: 1.1,
                    spaceBetween: 15,
                    slidesOffsetAfter: 20
                });
            }
        } else {
            if(row.classList.contains("swiper")) {
                let teaserSwiper = row.swiper;
                if(teaserSwiper) {
                    teaserSwiper.destroy();
                    row.classList.remove("swiper");
                }
            }
        }
    }
}

function collectionAthletesArticles() {
    Swiper.use([Navigation]);
    const swiper = new Swiper(".athletesSwiper", {
        slidesPerView: 1.15,
        navigation: {
            nextEl: '.athletesSwiper .swiper-button-next',
            prevEl: '.athletesSwiper .swiper-button-prev',
        },
        spaceBetween: 15,
        breakpoints: {
            767: {
              slidesPerView: 2.15
            },
            1024: {
                slidesPerView: 3.15
            }
        }
    });

}

function collectionTabs() {

    Swiper.use([Pagination]);
    const swiper = new Swiper(".tabsSwiper", {
        slidesPerView: 1,
        allowTouchMove: false,
        spaceBetween: 0,

        pagination: {
            el: ".tabPagination",
            clickable: true,
            renderBullet: function (index, className) {
                let slide = this.slides[index];
                let thumbUrl = slide.dataset.thumb;
                let thumbName = slide.dataset.title;
                return '<div class="' + className + '">' +
                    '<span class="tabThumb"><img src="' + thumbUrl + '" aria-hidden="true" /></span>' +
                    '<span class="tabThumbName">' + thumbName + '</span>' +
                    '</div>';
            },
        },
    });

    window.addEventListener("resize" , function () {
        if(window.innerWidth > 1023 || window.outerWidth > 1023) {

            let itemboxSliders = document.querySelectorAll(".tabArticle .itemboxList.swiper-initialized");
            for(let itemboxSlider of itemboxSliders) {
                let itemSwip = itemboxSlider.swiper;
                let count = itemboxSlider.offsetWidth / (425 + 15); //425 width of slide and 15 gap
                itemSwip.params.slidesPerView = count;
                itemSwip.update();
            }
        }
    });
}